"use client";

import { Button, DialogPortal } from "@medimo/ui";
import {
  Dialog,
  DialogClose,
  DialogCloseButton,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@medimo/ui";
import { useState } from "react";
import { useSubscriptionActive } from "../hooks/use-subscription-active";

export const SubscriptionAlertDialog = ({
  contactFormUrl,
}: { contactFormUrl: string }) => {
  const { isActive, isPending } = useSubscriptionActive();

  const [open, setOpen] = useState(true);

  if (isActive || isPending) return null;

  return (
    <Dialog open={open}>
      <DialogPortal>
        <DialogContent className="w-[328px] rounded md:w-[636px]">
          <DialogHeader>
            <DialogTitle className="text-left text-lg">
              重要なお知らせ
            </DialogTitle>
            <DialogCloseButton onClick={() => setOpen(false)} />
          </DialogHeader>
          <DialogDescription>
            <div className="flex flex-col justify-between gap-3">
              <p className="text-red-500">
                ご利用開始の準備がまだ完了していない可能性があります。
                <br />
                トライアル・ご契約開始前の場合は、初期設定のご案内（初期設定面談）後よりmedimoをご利用いただけます。
                <br />
                本契約中にもかかわらずご利用いただけない場合や、ご不明な点がある場合は、恐れ入りますが、担当者または
                <a
                  className="underline"
                  href={contactFormUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  サポート窓口
                </a>
                までお問い合わせください。
              </p>
              <div className="flex justify-end">
                <DialogClose asChild>
                  <Button
                    className="w-full font-bold md:w-1/4"
                    variant="outline_green"
                    onClick={() => setOpen(false)}
                  >
                    閉じる
                  </Button>
                </DialogClose>
              </div>
            </div>
          </DialogDescription>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
